import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

if (window.location.hostname.startsWith("www.")) {
  window.location.replace(window.location.href.replace("//www.", "//"));
}
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Chat from "@/pages/Chat";
import Listings from "@/pages/Listings";
import ListingDetail from "@/pages/ListingDetail";
import Rentals from "@/pages/Rentals";
import { HowItWorks, About, FAQ, Privacy, Terms, Contact, PosterScan } from "@/pages/Static";
import ForLandlords from "@/pages/ForLandlords";
import { Blog, BlogPost } from "@/pages/Blog";
import Account from "@/pages/Account";
import Unsubscribe from "@/pages/Unsubscribe";
import PrivacyDelete from "@/pages/PrivacyDelete";
import { MagicConsume } from "@/pages/auth/AuthPages";
import { StaffLogin, StaffForgot, StaffReset } from "@/pages/auth/StaffAuth";
import DashLayout from "@/pages/dashboard/DashLayout";
import Leads from "@/pages/dashboard/Leads";
import LeadDetail from "@/pages/dashboard/LeadDetail";
import Viewings from "@/pages/dashboard/Viewings";
import Inventory from "@/pages/dashboard/Inventory";
import ListingForm from "@/pages/dashboard/ListingForm";
import Companies from "@/pages/dashboard/Companies";
import Outreach from "@/pages/dashboard/Outreach";
import Ingestion from "@/pages/dashboard/Ingestion";
import Analytics from "@/pages/dashboard/Analytics";
import Users from "@/pages/dashboard/Users";
import Content from "@/pages/dashboard/Content";
import DataRequests from "@/pages/dashboard/DataRequests";
import EmailCentre from "@/pages/dashboard/EmailCentre";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Loading…</div>;
  if (!user || !["admin", "agent"].includes(user.role)) return <Navigate to="/staff" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster richColors position="top-center" />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/chat" element={<Chat />} />
              <Route path="/listings" element={<Listings />} />
              <Route path="/listings/:id" element={<ListingDetail />} />
              <Route path="/rentals/:slug" element={<Rentals />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/about" element={<About />} />
              <Route path="/for-landlords" element={<ForLandlords />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/privacy/delete" element={<PrivacyDelete />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/account" element={<Account />} />
              <Route path="/unsubscribe" element={<Unsubscribe />} />
              <Route path="/p/:code" element={<PosterScan />} />
              <Route path="/auth/magic" element={<MagicConsume />} />
            </Route>
            <Route path="/staff" element={<StaffLogin />} />
            <Route path="/staff/forgot" element={<StaffForgot />} />
            <Route path="/staff/reset" element={<StaffReset />} />
            <Route path="/dashboard" element={<Protected><DashLayout /></Protected>}>
              <Route index element={<Leads />} />
              <Route path="leads/:id" element={<LeadDetail />} />
              <Route path="viewings" element={<Viewings />} />
              <Route path="inventory" element={<Inventory />} />
              <Route path="inventory/new" element={<ListingForm />} />
              <Route path="inventory/:id/edit" element={<ListingForm />} />
              <Route path="companies" element={<Companies />} />
              <Route path="outreach" element={<Outreach />} />
              <Route path="data-requests" element={<DataRequests />} />
              <Route path="email" element={<EmailCentre />} />
              <Route path="ingestion" element={<Ingestion />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="users" element={<Users />} />
              <Route path="content" element={<Content />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
